import { autoinject, transient, bindable } from "aurelia-framework";

@autoinject
@transient()
export class WidgetAutoRefresh {

    @bindable
    public shouldAutoRefresh: boolean;

    @bindable
    public autoRefreshIntervalInMinutes: number;
}